export default {
  product: {
    addButton: '[data-add-to-cart]',
    addButtonQuickShop: '[data-add-button]',
    addButtonText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    form: '[data-product-form]',
    imageById: id => `[data-image-id='${id}']`,
    imageWrapper: '[data-product-image-wrapper]',
    optionById: id => `[value='${id}']`,
    price: '[data-product-price]',
    thumb: '[data-product-single-thumbnail]',
    thumbById: id => `[data-thumbnail-id='${id}']`,
    thumbs: '[data-product-thumbnails]',
    variantSelect: '[data-variant-select]',
    zoom: '[data-product-zoom]',
    storeAvailability: '[data-store-availability-container]',
  },
  a11y: {
    formStatus: '.form-status'
  }
};
